import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./LandingPage.scss";
import {
  IconWorld,
  IconFileAnalytics,
  IconArrowRight,
  IconPlayerPlay,
  IconBrandInstagram,
} from "@tabler/icons-react";

const REGIONS = [
  {
    region: "🇪🇸 Spain",
    items: [
      {
        label: "Instagram Reel",
        url: "https://www.instagram.com/reels/DPg5mXKjdd4/",
        platform: "instagram",
      },
      {
        label: "Facebook Video",
        url: "https://www.facebook.com/100076264382504/videos/la-tecnologia-cambia-il-modo-di-vedere-letteralmentecon-il-nuovo-campo-visivo-oc/1349783276811527/",
        platform: "facebook",
      },
    ],
  },
  {
    region: "🇬🇧 UK & Ireland",
    items: [
      {
        label: "YouTube Short",
        url: "https://www.youtube.com/shorts/WwmotSdOO0M",
        platform: "youtube",
      },
      {
        label: "Facebook: Digital Transformation",
        url: "https://www.facebook.com/DigitalTransformationFlexibleFund/videos/revolutionising-eye-care-with-ai-powered-vr-technology-%EF%B8%8F/2201974760212952/",
        platform: "facebook",
      },
      {
        label: "YouTube: Clinical Demo",
        url: "https://www.youtube.com/watch?v=uUzOO1XS-F8",
        platform: "youtube",
      },
      {
        label: "Facebook: Eyecare Berkhamsted",
        url: "https://www.facebook.com/eyecareberkhamsted/videos/come-and-try-out-our-new-oculera-visual-field-analysermakes-the-visual-field-tes/6242549245769451/",
        platform: "facebook",
      },
      {
        label: "Instagram Post",
        url: "https://www.instagram.com/p/DSJ-yuPDpbm/",
        platform: "instagram",
      },
    ],
  },
  {
    region: "🇳🇬 Nigeria",
    items: [
      {
        label: "YouTube Video",
        url: "https://www.youtube.com/watch?v=p6C7LeZ5LnU",
        platform: "youtube",
      },
    ],
  },
  {
    region: "🇲🇽 Mexico",
    items: [
      {
        label: "YouTube Video",
        url: "https://www.youtube.com/watch?v=ENOdifzy0yA",
        platform: "youtube",
      },
    ],
  },
  {
    region: "🇬🇷 Greece",
    items: [
      {
        label: "Facebook: Minopta",
        url: "https://www.facebook.com/minopta/videos/%CE%B7-minopta-%CE%B1%CE%BB%CE%BB%CE%AC%CE%B6%CE%B5%CE%B9-%CF%84%CE%B1-%CE%B4%CE%B5%CE%B4%CE%BF%CE%BC%CE%AD%CE%BD%CE%B1-%CF%83%CF%84%CE%B7%CE%BD-%CE%BF%CF%86%CE%B8%CE%B1%CE%BB%CE%BC%CE%BF%CE%BB%CE%BF%CE%B3%CE%AF%CE%B1-%CF%85%CE%B9%CE%BF%CE%B8%CE%B5%CF%84%CF%8E%CE%BD%CF%84%CE%B1%CF%82-%CF%84%CE%B5%CF%87%CE%BD%CE%BF%CE%BB%CE%BF%CE%B3%CE%AF%CE%B1-%CE%B5%CE%B9%CE%BA%CE%BF%CE%BD%CE%B9%CE%BA%CE%AE%CF%82/2295066547558704/",
        platform: "facebook",
      },
    ],
  },
  {
    region: "🇸🇪 Sweden",
    items: [
      {
        label: "Instagram Reel",
        url: "https://www.instagram.com/reels/DU8udjAjMoS/",
        platform: "instagram",
      },
    ],
  },
];

const PRESS = [
  {
    label: "Eye News: Headset Perimetry Review",
    url: "https://www.eyenews.uk.com/reviews/tech-reviews/post/headset-perimetry",
  },
  {
    label: "ABDO: VR Technology Coming to Practices",
    url: "https://www.abdo.org.uk/news/vr-technology-coming-to-practices/",
  },
  {
    label: "Optician Online: Hoya & Oculera Launch",
    url: "https://www.opticianonline.net/content/news/hoya-and-oculera-launch-vr-visual-field-analyser",
  },
];

export default function GlobalPage() {
  useEffect(() => {
    AOS.init({ once: true, duration: 600, offset: 40 });
  }, []);

  return (
    <div className="lp-root">
      <section className="lp-section lp-presence" id="presence" style={{ paddingTop: 80 }}>
        <div className="lp-container">
          <div className="lp-presence-header" data-aos="fade-up">
            <div className="lp-badge">
              <IconWorld size={12} />
              Global Reach
            </div>
            <h2 className="lp-section-title">Oculera Around the World</h2>
            <p className="lp-section-subtitle" style={{ margin: "0 auto 56px" }}>
              Clinicians, optometrists, and eye care professionals across six continents are already
              using Oculera VFA in their practices.
            </p>
          </div>

          <div className="lp-presence-grid">
            {REGIONS.map((group, gi) => (
              <div
                className="lp-presence-card"
                key={group.region}
                data-aos="fade-up"
                data-aos-delay={gi * 60}
              >
                <div className="presence-region">{group.region}</div>
                <div className="presence-links">
                  {group.items.map((item) => (
                    <a
                      key={item.url}
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`presence-link presence-link--${item.platform}`}
                    >
                      <span className="presence-link-icon">
                        {item.platform === "youtube" && <IconPlayerPlay size={13} />}
                        {item.platform === "instagram" && <IconBrandInstagram size={13} />}
                        {item.platform === "facebook" && <IconWorld size={13} />}
                      </span>
                      {item.label}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="lp-presence-news" data-aos="fade-up">
            <div className="presence-news-label">
              <IconFileAnalytics size={14} /> Press Coverage
            </div>
            <div className="presence-news-links">
              {PRESS.map((item) => (
                <a
                  key={item.url}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="presence-news-item"
                >
                  <IconArrowRight size={14} />
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
